let host = 'https://play-server.sherlockquiz.com';
let socket = 'play-server.sherlockquiz.com';

// eslint-disable-next-line no-undef
if (window.location.hostname === 'localhost') {
  host = 'http://localhost:5000';
  socket = 'localhost:8000';
}

export default {
  prefix: '/api',
  baseUrl: host,
  socketsTread: socket,

  /** CONFIG **/
  USE_AUDIO: true,
  USE_VIDEO: false,

  /** You should probably use a different stun server doing commercial stuff **/
  /** Also see: https://gist.github.com/zziuni/3741933 **/
  ICE_SERVERS: [
      {url:"stun:stun.l.google.com:19302"}
  ],
};



// WEBPACK FOOTER //
// ./src/scripts/config.js